import { getNameExtension } from '../../Files/helpers/getNameExtension';
import { isNotValidateSize } from '../../Files/helpers/isNotValidateSize';
import { useTranslation } from 'react-i18next';

const validatedFormat: string[] = ['jpg', 'jpeg', 'png', 'gif'];
enum Errors {
    FORMAT = i18next.t('useUploadImage.enum.Errors.FORMAT'),
    SIZE = i18next.t('useUploadImage.enum.Errors.SIZE'),
    COUNT = i18next.t('useUploadImage.enum.Errors.COUNT'),
}

export const useUploadImage = (onAddImage: (images: File[]) => void) => {
    const { t } = useTranslation();
    const onImageChange = (images: File[]) => {
        let uploadImageList = [];
        let overallSize = 0;
        if (images.length > 5) {
            //@ts-ignore
            swal({
                text: Errors.COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('swal.button.text.got_it'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }

        for (let i = 0; i < images.length; i++) {
            const { extension } = getNameExtension(images[i].name);
            if (!validatedFormat.includes(extension.toLowerCase())) {
                //@ts-ignore
                swal({
                    text: Errors.FORMAT,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('swal.button.text.got_it'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }

            const checkValidate = isNotValidateSize(images[i].size, 1000);

            if (checkValidate) {
                //@ts-ignore
                swal({
                    text: Errors.SIZE,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('swal.button.text.got_it'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }
            uploadImageList.push(images[i]);

            overallSize += images[i].size;
        }

        const isOverallSize = isNotValidateSize(overallSize, 1000);

        if (isOverallSize) {
            //@ts-ignore
            swal({
                text: Errors.SIZE,
                cancel: false,
                confirm: true,
                button: {
                    text: t('swal.button.text.got_it'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        onAddImage(uploadImageList);
    };

    return onImageChange;
};
